import { AngularFirestore, AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';
import { CurrencyPipe } from '@angular/common';
import { FirebaseDaoBase } from '../table/daos/firebase-dao-base';

import { TrDatePipe } from '../pipes/tr-date.pipe';
import { Customer } from './customer.model';
import { CustomerService } from './customer.service';

export class CustomerDao extends FirebaseDaoBase<any> {
  public customerId: string
  constructor(public customerService: CustomerService) {
    super();
  }
  
  public async getDataItems(customers?: Customer[]): Promise<Customer[]> {
    return customers;
  }

  public getCollection(): AngularFirestoreCollection {
    return this.customerService.getCollection()
  }

  public convertValuesToString(dataItem: any, key: string): string {
    switch (key) {
      case "quoteDate":
        return new TrDatePipe().transform(dataItem.quoteDate, "short");
      case "rockQuote":
      case "freightQuote":
      case "totalQuote":
        return new CurrencyPipe("en-US").transform(dataItem[key], "USD");
      default:
        return dataItem[key];
    }
  }
}



